module.exports = __webpack_public_path__ + "static/media/sound2.5c1e8b8a.wav";